<div class="card" style="border-radius: 10px">
  <div class="card-body">
    <div class="row text-left">
      <div class="col-sm-12">
        <div class="d-flex justify-content-between mb-0">
          <h1 class="text-bold-400" style="color: #4e7977">
            Instâncias WhatsApp
          </h1>
        </div>
      </div>
      <div class="col-sm-12">
        <p class="mb-2 mt-2" style="font-size: 20px">
          Gerencie as instâncias do WhatsApp (UAZAPI). Crie novas instâncias, conecte via QR Code ou código de pareamento, edite nomes e visualize o status.
        </p>
      </div>
    </div>

    <div class="form-row d-flex justify-content-end align-items-center mt-3">
      <div class="col-auto">
        <button type="button" class="btn btn-primary" (click)="openModalNova(modalNova)">
          <i class="fa fa-plus mr-2"></i>Nova instância
        </button>
      </div>
    </div>
  </div>
</div>

<div class="card" style="border-radius: 10px" *ngIf="instancias.length > 0">
  <div class="card-body">
    <table class="table text-center" style="padding: 10px">
      <thead>
        <tr>
          <th>Nome</th>
          <th>Status</th>
          <th>Perfil</th>
          <th>Última desconexão</th>
          <th>Ações</th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let inst of instancias">
          <td class="align-middle">{{ inst.nome }}</td>
          <td class="align-middle">
            <span class="badge" [ngClass]="statusClass(inst.status)">{{ statusLabel(inst.status) }}</span>
          </td>
          <td class="align-middle">
            <span class="d-inline-flex align-items-center">
              <img *ngIf="inst.profile_pic_url" [src]="inst.profile_pic_url" alt="" class="perfil-avatar mr-2" />
              <span *ngIf="inst.profile_name">{{ inst.profile_name }}</span>
              <span *ngIf="!inst.profile_name && !inst.profile_pic_url" class="text-muted">–</span>
            </span>
          </td>
          <td class="align-middle">
            <span class="ultima-disconnect-cell">
              <span *ngIf="inst.last_disconnect">{{ formatarDataDesconexao(inst.last_disconnect) }}</span>
              <span *ngIf="!inst.last_disconnect" class="text-muted">–</span>
              <span class="ultima-disconnect-tooltip" *ngIf="inst.last_disconnect_reason">{{ inst.last_disconnect_reason }}</span>
            </span>
          </td>
          <td class="align-middle">
            <div class="btn-group btn-group-sm">
              <button type="button" class="btn btn-outline-primary mr-1" (click)="openModalEditar(modalEditar, inst)" title="Editar nome">
                <i class="fa fa-edit"></i>
              </button>
              <button type="button" class="btn btn-outline-success mr-1" (click)="openModalConectar(modalConectar, inst)" *ngIf="inst.status !== 'connected'" title="Conectar">
                <i class="fa fa-link"></i> Conectar
              </button>
              <button type="button" class="btn btn-outline-primary mr-1" (click)="openModalEnviar(modalEnviar, inst)" *ngIf="inst.status === 'connected'" title="Enviar mensagem">
                <i class="fa fa-send"></i> Enviar
              </button>
              <button type="button" class="btn btn-outline-danger" (click)="excluir(inst)" title="Excluir">
                <i class="fa fa-trash"></i>
              </button>
            </div>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</div>

<div class="card" style="border-radius: 10px" *ngIf="instancias.length === 0">
  <div class="card-body">
    <div class="text-center py-4">
      <h5 class="mt-0">Nenhuma instância cadastrada</h5>
      <p class="text-muted">Clique em "Nova instância" para criar uma instância WhatsApp.</p>
      <button type="button" class="btn btn-primary" (click)="openModalNova(modalNova)">
        <i class="fa fa-plus mr-2"></i>Nova instância
      </button>
    </div>
  </div>
</div>

<!-- Modal Nova instância -->
<ng-template #modalNova let-modal>
  <div class="card">
    <div class="card-header">
      <h4 class="card-title">Nova instância</h4>
    </div>
    <div class="card-body">
      <div class="form-group">
        <label for="novaNome">Nome da instância</label>
        <input type="text" id="novaNome" class="form-control" [(ngModel)]="novaInstancia.name" placeholder="Ex: Atendimento" [readonly]="criandoInstancia" />
      </div>
      <div class="d-flex justify-content-end mt-3">
        <button type="button" class="btn btn-secondary mr-2" (click)="modal.close('Close click')" [disabled]="criandoInstancia">Cancelar</button>
        <button type="button" class="btn btn-primary" (click)="criarInstancia(modal)" [disabled]="!novaInstancia.name?.trim() || criandoInstancia">
          <span *ngIf="criandoInstancia"><i class="fa fa-spinner fa-spin mr-1"></i>Criando...</span>
          <span *ngIf="!criandoInstancia">Criar</span>
        </button>
      </div>
    </div>
  </div>
</ng-template>

<!-- Modal Editar nome -->
<ng-template #modalEditar let-modal>
  <div class="card">
    <div class="card-header">
      <h4 class="card-title">Editar nome</h4>
    </div>
    <div class="card-body">
      <div class="form-group">
        <label for="editarNome">Nome</label>
        <input type="text" id="editarNome" class="form-control" [(ngModel)]="editarInstancia.name" placeholder="Nome da instância" />
      </div>
      <div class="d-flex justify-content-end mt-3">
        <button type="button" class="btn btn-secondary mr-2" (click)="modal.close('Close click')">Cancelar</button>
        <button type="button" class="btn btn-primary" (click)="salvarNome(modal)" [disabled]="!editarInstancia.name?.trim()">Salvar</button>
      </div>
    </div>
  </div>
</ng-template>

<!-- Modal Conectar (QR / Paircode) -->
<ng-template #modalConectar let-modal>
  <div class="card">
    <div class="card-header d-flex justify-content-between align-items-center">
      <h4 class="card-title mb-0">Conectar: {{ instanciaConectando?.nome }}</h4>
      <button type="button" class="close" (click)="fecharModalConectar(modal)" aria-label="Fechar"><span aria-hidden="true">&times;</span></button>
    </div>
    <div class="card-body text-center">
      <p *ngIf="statusConectando?.instance?.status === 'connecting'" class="text-muted">Escaneie o QR Code com o WhatsApp no celular ou insira o código de pareamento.</p>
      <div *ngIf="statusConectando?.qrcode" class="mb-3">
        <img [src]="statusConectando.qrcode" alt="QR Code" style="max-width: 220px; height: auto;" />
      </div>
      <div *ngIf="statusConectando?.paircode && !statusConectando?.qrcode" class="mb-3">
        <p class="font-weight-bold">Código de pareamento</p>
        <code class="d-block p-3 bg-light rounded" style="font-size: 1.2rem">{{ statusConectando.paircode }}</code>
      </div>
      <div *ngIf="statusConectando?.instance?.status === 'connected'" class="text-success">
        <i class="fa fa-check-circle fa-3x mb-2"></i>
        <p class="mb-0">Conectado. Você pode fechar esta janela.</p>
      </div>
      <div *ngIf="statusConectando?.instance?.status === 'disconnected' && instanciaConectando?.status !== 'connecting'" class="text-warning">
        <p class="mb-0">Conexão encerrada ou não estabelecida.</p>
      </div>
      <div *ngIf="!statusConectando && instanciaConectando" class="text-muted">
        <ngx-spinner></ngx-spinner>
        <p class="mt-2">Iniciando conexão...</p>
      </div>
      <div class="mt-3">
        <button type="button" class="btn btn-secondary" (click)="fecharModalConectar(modal)">Fechar</button>
      </div>
    </div>
  </div>
</ng-template>

<!-- Modal Enviar mensagem -->
<ng-template #modalEnviar let-modal>
  <div class="card">
    <div class="card-header">
      <h4 class="card-title">Enviar mensagem ({{ instanciaEnviar?.nome }})</h4>
    </div>
    <div class="card-body">
      <div class="form-group">
        <label for="enviarNumber">Número (ex.: 5511999999999)</label>
        <input type="text" id="enviarNumber" class="form-control" [(ngModel)]="enviarMsg.number" placeholder="5511999999999" [readonly]="enviandoMensagem" />
      </div>
      <div class="form-group">
        <label for="enviarText">Mensagem</label>
        <textarea id="enviarText" class="form-control" [(ngModel)]="enviarMsg.text" rows="4" placeholder="Digite o texto" [readonly]="enviandoMensagem"></textarea>
      </div>
      <div class="d-flex justify-content-end mt-3">
        <button type="button" class="btn btn-secondary mr-2" (click)="modal.close('Close click')" [disabled]="enviandoMensagem">Cancelar</button>
        <button type="button" class="btn btn-primary" (click)="enviarMensagem(modal)" [disabled]="!enviarMsg.number?.trim() || !enviarMsg.text?.trim() || enviandoMensagem">
          <span *ngIf="enviandoMensagem"><i class="fa fa-spinner fa-spin mr-1"></i>Enviando...</span>
          <span *ngIf="!enviandoMensagem">Enviar</span>
        </button>
      </div>
    </div>
  </div>
</ng-template>

<ngx-spinner></ngx-spinner>
